<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="openAddDialog">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="图片"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.brand_img"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              plain
              @click="handlerEdit(scope)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

    <el-dialog
      :title="dialogType==0? '新增': '编辑'"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="500px">

      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="editObject.brand_name"/>
        </el-form-item>
        <el-form-item label="英文标题">
          <el-input v-model="editObject.brand_english_name"/>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="editObject.url"/>
        </el-form-item>
        <el-form-item label="权重">
          <el-input-number
            v-model="editObject.sort"
            :min="1" />
            <!-- <el-input v-model="editObject.sort"/> -->
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadSuccess"
            :show-file-list="false">
            <img
              v-if="editObject.brand_img"
              :src="qiniuDomain + editObject.brand_img"
              class="avatar">
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSaveClick()">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
// import {
//   cooperateBrandList, addCooperateBrand, editCooperateBrand, delCooperateBrand,
// } from '@/api/about'
import {
  cooperateBrandList, editCooperateBrand, delCooperationBrand, addCooperatenBrand,
} from '@/api/about'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      dialogType: 0, //  0-新增、1-编辑
      editObject: { //  根据接口来的命名，不是很喜欢---
        brand_name: '',
        brand_english_name: '',
        url: '',
        brand_img: '',
        sort: '',
        uuid: '',
      },
      config: {
        // pagination: true,
        size: 5,
        fields: [
          {
            prop: 'brand_name',
            label: '标题',
          },
          {
            prop: 'brand_english_name',
            label: '英文标题',
          },
          {
            prop: 'url',
            label: '跳转链接',
          },
          {
            prop: 'sort',
            label: '权重',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      pageIndex: 1,
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().cooperateBrandList()
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().cooperateBrandList()
    },
    handlerEdit(data) {
      this.dialogType = 1 // 编辑框
      this.editObject.brand_name = data.row.brand_name
      this.editObject.brand_english_name = data.row.brand_english_name
      this.editObject.url = data.row.url
      this.editObject.sort = data.row.sort
      this.editObject.brand_img = data.row.brand_img
      this.editObject.uuid = data.row.uuid
      this.dialogEdit = true
    },
    handlerDel(data) {
      this.network().delCooperationBrand(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.brand_name = ''
      this.editObject.brand_english_name = ''
      this.editObject.url = ''
      this.editObject.sort = ''
      this.editObject.brand_img = ''
      this.editObject.uuid = ''
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.brand_img = res.hash
    },
    event() {
      return {
        onSaveClick: () => {
          if (!this.event().inputVerify()) return
          //  dialogType: 0-新增、1-编辑
          if (this.dialogType === 0) {
            this.network().addCooperatenBrand()
          } else {
            this.network().editCooperateBrand()
          }
        },
        inputVerify: () => {
          if (!this.editObject.brand_name) {
            this.$message('请填写标题')
            return false
          }
          if (!this.editObject.brand_english_name) {
            this.$message('请填写英文标题')
            return false
          }
          // eslint-disable-next-line
          const httpReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
          if (this.editObject.url && !httpReg.test(this.editObject.url)) {
            this.$message('跳转链接格式不正确')
            return false
          }
          if (!this.editObject.sort) {
            this.$message('请填写权重')
            return false
          }
          if (!this.editObject.brand_img) {
            this.$message('请上传图片')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        cooperateBrandList: async () => {
          const { status, data } = await cooperateBrandList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addCooperatenBrand: async () => {
          const { status } = await addCooperatenBrand(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().cooperateBrandList()
          }
        },
        editCooperateBrand: async () => {
          const { status } = await editCooperateBrand(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().cooperateBrandList()
          }
        },
        delCooperationBrand: async (uuid) => {
          const { status } = await delCooperationBrand({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().cooperateBrandList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/about/cooperate-brand-list.vue